import { CONNECT_TO_SOCKET, AUTHORIZE_WITH_SOCKET, DISCONNECT_FROM_SOCKET, SEND_TO_SOCKET } from './consts';
export const connectToSocket = (config) => ({
    type: CONNECT_TO_SOCKET,
    meta: config
});
export const authorizeWithSocket = (type) => ({
    type: AUTHORIZE_WITH_SOCKET,
    meta: { type }
});
export const disconnectFromSocket = (type) => ({
    type: DISCONNECT_FROM_SOCKET,
    meta: { type }
});
export const sendToSocket = (type, payload) => ({
    type: SEND_TO_SOCKET,
    meta: { type },
    payload
});
//# sourceMappingURL=actionCreators.js.map